import Vue from 'vue';
import tippy from 'tippy.js';
import { get } from 'lodash';

/**
 * Usage:
 * <span v-tooltip="'This is disabled'" />
 */
Vue.directive('tooltip', {
  inserted(el, binding) {
    const content = get(binding, 'value');

    if (!content) {
      return;
    }

    tippy(el, {
      arrow: get(binding, 'modifiers.arrow', false),
      placement: get(binding, 'arg', 'right'),
      offset: get(binding, 'value.offset', [-55,25]),
      content,
    });
  },
});
